module.exports = __webpack_public_path__ + "static/media/icon-aluguel-fortalecimento.33e311f3.webp";